<template>
  <section>
    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="true"></loading>
    </div>
    <div class="header">
      <span>
        <div class="header-box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <div class="title-text"> Hello, {{ profile.displayName | '' }} </div>
                <div class="title-bold"> Confirm Transaction </div>
              </div>
            </div>
            <div class="media-right">
              <figure class="image is-64x64">
                <img v-if=profile.pictureUrl class="is-rounded" :src=profile.pictureUrl alt="Image">
                <img v-else class="is-rounded" src="https://test.iyawat.com/libra-chatbot/nodejs/images/libra-bg.jpg" alt="img" style="width: 50px;    margin: 0 auto;">
              </figure>
            </div>
          </article>
        </div>
      </span>
    </div>
  <div class="Wallet">
    <section>
      <div class="wallet-body">
        <div class="wallet-box">

        <b-field class="label-head"
          :label="labelHead" >
            <b-input placeholder="Destination Address..."
              type="textarea"
              rows="2"
              maxlength="64"
              v-model="address"
              :disabled="!editable"
            >
            </b-input>
        </b-field>

        <b-field class="label-head"
          label="Amount: ">
            <b-input placeholder="Amount..."
              type="text"
              pattern="^\d*(\.\d{0,2})?$"
              v-model="amount"
              :disabled="!editable"
            >
            </b-input>
        </b-field>

        </div>
      </div>

      <div class="button-box">
          <b-button
            style="background-color: green; color: white"
            icon-left="check-double"
            @click="Transfer"
          >
            Confirm
          </b-button>
          <br>
	  <b-button
            icon-left="arrow-left"
            @click="back"
          >
            Back
          </b-button>
      </div>
    </section>
  </div>
  <FooterBar />
  </section>

</template>

<script>
// require styles
import FooterBar from '@/views/Footer'
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import UserDataPersistance from '@/userData/persistance'
import { mapState, mapActions } from 'vuex'
import { ToastProgrammatic as Toast } from 'buefy'
import axios from 'axios'

export default {
  name: 'Home',
  components: {
    FooterBar,
    Loading
  },
  data: () => ({
    isLoading: true,
    userData: null,
    fetched: false,
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    address: '',
    amount: '10',
    labelHead: 'To Address: ',
    labelValue: '',
    editable: true
  }),
  filters: {
    numberWithCommas (x) {
      if (x !== undefined) {
        let parts = x.toString().split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        return parts.join('.')
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.getProfile()
    }, 1000)
    // Load from local storage
    this.userData = new UserDataPersistance()
    if (!this.wallet.mnemonic) {
      Toast.open({
        message: 'Error cannot find mnemonic',
        type: 'is-danger'
      })
      this.$router.push({ name: 'Home' })
    }
    if (this.$route.query) {
      if (this.$route.query.to) {
        this.address = this.$route.query.to
      }
      if (this.$route.query.amount !== undefined) {
        this.amount = this.$route.query.amount
      }
      if (this.$route.query.editable !== undefined) {
        this.editable = this.$route.query.editable
      }
      if (this.$route.query.labelHead !== undefined) {
        this.labelHead = this.$route.query.labelHead + ': ' + this.$route.query.labelValue
      }
    }
  },
  computed: {
    ...mapState({
      wallet: state => state.wallet
    })
  },
  methods: {
    ...mapActions({
      updateWallet: 'updateWallet'
    }),
    getProfile () {
      let _this = this
      this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
        _this.isLoading = false
      }).catch(function (error) {
        Toast.open({
          message: 'Error getting profile: ' + error,
          type: 'is-danger'
        })
      })
    },
    async updatePersistance (userAddress, balance, mnemonic) {
      this.userData.update(userAddress, balance, mnemonic)
      this.userData.save()
    },
    back () {
      this.$router.push({ name: 'Home' })
    },
    async Transfer () {
      this.isLoading = true
      let data = {
        fromAddress: this.wallet.accountno,
        mnemonic: this.wallet.mnemonic,
        toAddress: this.address,
        amount: this.amount
      }
      axios.get('https://libra-chatbot.iyawat.com/Transfer', { params: data }).then(response => {
        // this.transactions = response.data
        // alert(JSON.stringify(response.data))
        this.transactions = response.data
        this.fetched = true
        this.isLoading = false
        this.$router.push({
          name: 'Receipt',
          query: {
            address: this.address,
            amount: this.amount,
            receiptId: this.address.substr(0, 7),
            merchant: this.labelHead,
            message: response.data
          }
        })
      }).catch(error => {
        Toast.open({
          message: 'Error sending trx ' + error,
          type: 'is-danger'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  main, html, body {
    font-family: 'Prompt', sans-serif;
    overflow-x: none;
    -webkit-overflow-scrolling: touch;
    background-color: #F4F4F4;
  }
  .header {
    overflow:hidden;
  }
  .header-box {
    background-color: rgb(76, 0, 114);
    border-radius: 0;
    padding: 5% 5% 5% 5%;
  }
  .title-bar {
    background-color: rgb(76, 0, 114);
  }
  .title-text {
    font-size: 20px;
    font-weight: 500;
    color: #fff;
    letter-spacing: .5px;
  }
  .title-bold{
    font-weight: 400;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.801);
    letter-spacing: .5px;
  }

.wrapper {
  background-color: #fff;
  border-radius: 1rem;
  margin: 0 auto;
  max-width: 500px;
  padding: 2rem;
  width: 100%;
}

.footer {
  font-size: .8rem;
  margin-bottom: 0;
  margin-top: 3rem;
}

h1,
p {
  margin-bottom: 2rem;
}

h1 {
  font-family: 'Poppins', sans-serif;
  font-size: 1.7rem;
}

a {
  color: #31c1ef;
  text-decoration: none;
}

.wallet-body {
  background-color: #bab3fd;
}
.wallet-box {
  padding: 2rem 20px;
  background-color: #bab3fd;
}

input:disabled {
  color: #313131;
}

</style>
